export const en = {
    "k_c78ca785": "Failed to open editor: Missing application ID or page ID parameter",
    "k_12477066": "Failed to open editor: page does not exist"
};
